export default class Heart extends Phaser.Group {
  constructor(game, x, y) {
    super(game);

    this.x = x;
    this.y = y;

    this.asset = this.game.make.image(0, 0, 'heart');
    this.asset.anchor.set(0.5);
    this.addChild(this.asset);

    this.asset.alpha = 0;
    this.asset.scale.set(0);

    this.game.add.tween(this.asset).to({ alpha: 1 }, 200, null, true);
    this.game.add
      .tween(this.asset.scale)
      .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Quadratic.Out, true);
    this.game.add.tween(this.asset).to({ y: -50 }, 1000, Phaser.Easing.Quadratic.Out, true);
    this.game.add
      .tween(this)
      .to({ alpha: 0 }, 200, Phaser.Easing.Quadratic.In, true, 800)
      .onComplete.add(this.handleAnimEnd, this);

    this.game.sounds.playSFX('generic_heart', { spriteID: 'sfx' });
  }

  handleAnimEnd() {
    this.destroy();
  }
}
